module.exports = __webpack_public_path__ + "img/current_s.a5266bb3.png";